import { Blocks, Button, Logs, X } from "@repo/ui";
import type { FieldViewType } from "../item-detail-window";

type Props = {
  onClose: () => void;
  activeView: FieldViewType;
  onViewChange: (view: FieldViewType) => void;
};

export const ItemExplorerToolbar = ({ onClose, activeView, onViewChange }: Props) => {
  return (
    <div className="flex items-center justify-between px-3 pt-2.5">
      <Button onClick={onClose} variant="outline" icon={<X className="h-4 w-4" />} title="Close" />

      <div className="flex items-center gap-1">
        <Button
          onClick={() => onViewChange("log")}
          variant={activeView === "log" ? "primary" : "outline"}
          icon={<Logs className="h-4 w-4" />}
          title="Logs"
        />
        <Button
          onClick={() => onViewChange("meta")}
          variant={activeView === "meta" ? "primary" : "outline"}
          icon={<Blocks className="h-4 w-4" />}
          title="Metadata"
        />
      </div>
    </div>
  );
};
